import React, { useCallback } from 'react';
import { useNotificationActions } from '../NotificationProvider';
import NotificationItem from '../NotificationItem';

var ItemWrapper = function ItemWrapper(_ref) {
  var _ref$notification = _ref.notification,
      id = _ref$notification.id,
      type = _ref$notification.type,
      duration = _ref$notification.duration,
      message = _ref$notification.message;

  var _useNotificationActio = useNotificationActions(),
      removeNotification = _useNotificationActio.removeNotification;

  var onClose = useCallback(function () {
    removeNotification(id);
  }, [removeNotification, id]);
  return /*#__PURE__*/React.createElement(NotificationItem, {
    type: type,
    onClose: onClose,
    duration: duration,
    message: message
  });
};

export default ItemWrapper;